export default __webpack_public_path__ + "static/media/intro-background-chords.34e9bae6.svg";